const DAY_KEY = /^(\d{4})-(\d{2})-(\d{2})$/;
const INPUT = /^(\d{2})\/(\d{2})\/(\d{4})$/;
const DAY_MS = 86_400_000;

const pad = (value: number): string => String(value).padStart(2, '0');

const parts = (key: string): [number, number, number] | null => {
    const match = DAY_KEY.exec(key);
    if (!match) return null;
    const [, year, month, day] = match.map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
    return [year, month, day];
};

export const isDayKey = (value: unknown): value is string => typeof value === 'string' && parts(value) !== null;

export const localDayKey = (date: Date = new Date()): string =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const dayKeyToInput = (key: string | null | undefined): string => {
    const found = key ? parts(key) : null;
    return found ? `${pad(found[2])}/${pad(found[1])}/${found[0]}` : '';
};

export const inputToDayKey = (value: string): string | null => {
    const match = INPUT.exec(value.trim());
    if (!match) return null;
    const key = `${match[3]}-${match[2]}-${match[1]}`;
    return isDayKey(key) ? key : null;
};

export const addMonthsToDayKey = (key: string, months: number): string => {
    const found = parts(key);
    if (!found || !Number.isInteger(months)) return key;
    const [year, month, day] = found;
    const target = new Date(Date.UTC(year, month - 1 + months, 1));
    const last = new Date(Date.UTC(target.getUTCFullYear(), target.getUTCMonth() + 1, 0)).getUTCDate();
    target.setUTCDate(Math.min(day, last));
    return target.toISOString().slice(0, 10);
};

export const addDaysToDayKey = (key: string, days: number): string => {
    const found = parts(key);
    if (!found || !Number.isInteger(days)) return key;
    const date = new Date(Date.UTC(found[0], found[1] - 1, found[2] + days));
    return date.toISOString().slice(0, 10);
};

export const daysBetweenKeys = (from: string, to: string): number => {
    const start = parts(from);
    const end = parts(to);
    if (!start || !end) return 0;
    return Math.round((Date.UTC(end[0], end[1] - 1, end[2]) - Date.UTC(start[0], start[1] - 1, start[2])) / DAY_MS);
};

export const monthsBetweenKeys = (from: string, to: string): number => {
    const start = parts(from);
    const end = parts(to);
    if (!start || !end) return 0;
    return (end[0] - start[0]) * 12 + (end[1] - start[1]);
};
